module.exports = __webpack_public_path__ + "img/screenshot.d8a9ca46.png";